export default __webpack_public_path__ + "static/media/Trustage Dark.bd4abbd1.svg";